import { render, staticRenderFns } from "./PosOrder.vue?vue&type=template&id=dc6e07a0&scoped=true"
import script from "./PosOrder.vue?vue&type=script&lang=ts"
export * from "./PosOrder.vue?vue&type=script&lang=ts"
import style0 from "./PosOrder.vue?vue&type=style&index=0&id=dc6e07a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../Yobo/qraved-ordering-backoffice/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6e07a0",
  null
  
)

export default component.exports